import { useTranslation } from 'react-i18next';
import { useSongs } from '../api/songs';
import { useMyProgress } from '../api/takes';
import { useMembership } from '../auth/session';
import { ErrorView } from '../components/Guards';
import { SongsTable } from '../components/SongsTable';
import ui from '../styles/ui.module.css';

/**
 * Kitaplık for chorists (and every member who is not the director): every song in the choir's library
 * with their own part, grade and status, not only the next event's. The director's Kitaplık manages them.
 */
export function ChoristLibraryPage() {
  const { t } = useTranslation();
  const membership = useMembership();
  const songs = useSongs(membership?.choirId);
  const progress = useMyProgress(membership?.choirId);
  if (!membership) return null;
  const part = membership.defaultPart;
  const bySong = new Map((progress.data ?? []).map((p) => [p.songId, p]));

  return (
    <div className={ui.page}>
      <div className={ui.pageHeader}>
        <div>
          <div className={ui.eyebrow}>{membership.choirName}</div>
          <h1>{t('choristLibrary.title')}</h1>
          <div className={ui.subtitle}>
            {songs.data && t('choristLibrary.count', { count: songs.data.length })}
            {part && ` · ${t('home.yourPart', { part: t(`parts.${part}`) })}`}
          </div>
        </div>
      </div>
      <section className={ui.card} data-testid="songs-card">
        {songs.isPending && <p className={ui.muted}>{t('common.loading')}</p>}
        {songs.isError && <ErrorView onRetry={() => void songs.refetch()} />}
        {songs.data && songs.data.length === 0 && <p className={ui.empty}>{t('home.noSongs')}</p>}
        {songs.data && songs.data.length > 0 && <SongsTable songs={songs.data} part={part} progress={bySong} />}
      </section>
    </div>
  );
}
